module.exports = __webpack_public_path__ + "static/media/s_v10_6.cd279616.mp3";